/*=========================================================================================
  File Name: modulePermissionsActions.js
  Description: Permissions Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	// Consulta los permisos
	getPermissions({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/permission")
				.then((res) => {
					commit("SET_PERMISSIONS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Consula las relaciones Rol-permiso
	getRolePermission({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/rolepermission")
				.then((res) => {
					commit("SET_ROLE_PERMISSIONS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Consulta los roles
	getRoles({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/role")
				.then((res) => {
					commit("SET_ROLES", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Crea un permiso
	addPermission({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/permission", object)
				.then((response) => {
					//this.dispatch('moduleRoles/getRoles')
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Actualiza el Permiso
	updatePermission({commit}, permission) {
		let id = permission.id;
		delete permission["id"];
		return new Promise((resolve, reject) => {
			Api.put(`/permission/${id}`, JSON.stringify(permission))
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Elimina el Permiso
	removePermission({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/permission/${itemId}`)
				.then((response) => {
					commit("REMOVE_PERMISSION", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
